import { createContext, useContext, useState, useCallback } from 'react';
import { SnackDialog } from 'components';

const SnackContext = createContext({
  openSnack: () => {},
  closeSnack: () => {},
});

export function SnackProvider({ children }) {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
    autoHideDuration: 3000,
    anchorOrigin: { vertical: "bottom", horizontal: "center" },
  });

  const openSnack = useCallback((message, severity = "success", options = {}) => {
    setSnack({
      open: true,
      message,
      severity,
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      ...options,
    });
  }, []);

  const closeSnack = useCallback(() => {
    setSnack(prev => ({ ...prev, open: false }));
  }, []);

  return (
    <SnackContext.Provider value={{ openSnack, closeSnack }}>
      {children}
      
      <SnackDialog
        open={snack.open}
        message={snack.message}
        severity={snack.severity}
        autoHideDuration={snack.autoHideDuration}
        anchorOrigin={snack.anchorOrigin}
        onClose={closeSnack}
      />
    </SnackContext.Provider>
  );
}

export const useSnack = () => {
  const context = useContext(SnackContext);
  
  if (!context) {
    throw new Error('useSnack must be used within a SnackProvider');
  }
  
  return context;
};